<nz-layout class="entry-login">
  <nz-content>
    <nz-card [nzBordered]="true">
      <div class="logo">
        <img src="assets/logo.svg" />
      </div>

      <div class="content">
        <h4>Сервис управления релизами</h4>
        <span>Войдите в систему, чтобы продолжить работу.</span>

        <div>
          <button nz-button nzType="primary" nzSize="large" (click)="login()">
            <span nz-icon nzType="login"></span>
            Войти
          </button>
        </div>
      </div>

      <p class="copyright">© BFS, {{ currentYear }}</p>
    </nz-card>
  </nz-content>
</nz-layout>
